
import { Inject } from "vue-property-decorator"
import { Options, Vue } from "vue-class-component"

@Options({
  name: "input-element",
  props: ["modelValue"]
})
export default class InputElement extends Vue {
  @Inject() config: any
  readonly modelValue: any
  minWidth: string|null = '226px'

  get label() {
    const label = this.modelValue.meta?.label
    return !!label ? label : "标签"
  }

  created() {
    const element = this.modelValue
    if (!!element && !element.meta) {
      element.meta = {}
    }
  }
}
